<app-character [seed]="seed + '-1'" [magicChance]="0.10"></app-character>
<app-character [seed]="seed + '-2'"></app-character>
<app-character [seed]="seed + '-3'"></app-character>
<app-character [seed]="seed + '-4'"></app-character>
